import { render, staticRenderFns } from "./vRow.vue?vue&type=template&id=ec06c53c&scoped=true&"
import script from "./vRow.vue?vue&type=script&lang=js&"
export * from "./vRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec06c53c",
  null
  
)

export default component.exports